import React from 'react';
import { useAtom } from 'jotai';
import { kreedaAtom } from '../../../jotai/atoms/kreeda';
const Clues = () => {
    const [{ data }] = useAtom(kreedaAtom);
    if (!data?.kreedaData) {
        return React.createElement("div", null, "Loading...");
    }
    const crosswordData = data.kreedaData;
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null, "Across:"),
        crosswordData.hints?.across?.map((hint, i) => (React.createElement("div", { className: `clue clue-${hint.number}-across`, key: i },
            hint.number,
            ": ",
            hint.clue))),
        React.createElement("h3", null, "Down:"),
        crosswordData.hints?.down?.map((hint, i) => (React.createElement("div", { className: `clue clue-${hint.number}-down`, key: i },
            hint.number,
            ": ",
            hint.clue)))));
};
export { Clues };
